import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { TRequestConfig } from 'loop-front';

axios.defaults.headers.post['Content-Type'] = 'application/json';
// const IMAGE_KIT_URL = 'https://mithya.imagekit.io/stayuncle/';

let utilities = {
    updateItemList: function <T extends { id: string } = any>(list: Array<T> = [], item: T, action: 'ADD' | 'DELETE' | 'UPDATE' | 'PUT') {
        list = list || [];
        let newList = list.slice();
        let itemIndex: number;
        if (action === 'UPDATE') {
            itemIndex = newList.findIndex(listItem => item.id === listItem.id);
            if (itemIndex !== -1)
                newList.splice(itemIndex, 1, { ...newList[itemIndex], ...item, });
            return newList;
        } else if (action === 'ADD') {
            newList.unshift(item);
            return newList;
        } else if (action === 'DELETE') {
            return newList.filter(listItem => item.id !== listItem.id);
        }
        else if (action === 'PUT') {
            itemIndex = newList.findIndex(listItem => item.id === listItem.id);
            if (itemIndex !== -1)
                newList.splice(itemIndex, 1, { ...newList[itemIndex], ...item, });
            else {
                newList.push(item);
            }
            return newList;
        }
        return newList;
    },

    saveUser: (accessToken: string = '', userId: string = '') => {
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('userId', userId);
    },
    clearCookies: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('userId');
    },

    isAuthenticated: () => {
        return Boolean(localStorage.getItem('access_token'));
    },

    getUserId: () => {
        return localStorage.getItem('userId');
    },
    getAccessToken: () => {
        return localStorage.getItem('access_token');
    },

    request: (config: AxiosRequestConfig & TRequestConfig) => {
        console.log('API Request', `${axios.defaults.baseURL}/${config.url}`);
        console.log('Config', config);
        return axios.request(config);
    },
    jsonParser: (data: any, keys: Array<string>) => {
        let updatedObject: any
        if (Array.isArray(data)) {
            updatedObject = [...data];
            updatedObject.forEach((objItem: any) => {
                for (let i = 0; i < keys.length; i++) {
                    try {
                        if (typeof objItem[keys[i]] === 'string') objItem[keys[i]] = JSON.parse(objItem[keys[i]])
                        else continue;
                    } catch (e) { objItem[keys[i]] = {} }
                }
            });
        }
        else {
            updatedObject = { ...data };
            for (let i = 0; i < keys.length; i++) {
                try {
                    if (typeof data[keys[i]] === 'string') updatedObject[keys[i]] = JSON.parse(data[keys[i]]);
                    else continue;
                } catch (e) { updatedObject[keys[i]] = {} }
            }
        }
        return updatedObject;
    },

    validateEmail: (email: string) => {
        // eslint-disable-next-line
        let tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        if (!email)
            return false;

        if (email.length > 254)
            return false;

        var valid = tester.test(email);
        if (!valid)
            return false;

        // Further checking of some things regex can't handle
        var parts = email.split("@");
        if (parts[0].length > 64)
            return false;

        var domainParts = parts[1].split(".");
        if (domainParts.some(function (part) { return part.length > 63; }))
            return false;

        return true
    },

    validateUrl: (uri: string): boolean => {
        // eslint-disable-next-line
        let tester = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
        if (!uri) return false;
        return tester.test(uri);
    },

    toggleItemFromList: function <T extends { id: string } = any>(list: T[] = [], item: T, key: string = 'id', comparisonFunction?: (currentItem: T, item: T) => boolean) {
        let updatedList: T[] = [...list];
        let index = list.findIndex(i => comparisonFunction ? comparisonFunction(i, item) : i[key as 'id'] === item[key as 'id']);
        index === -1 ? updatedList.push(item) : updatedList.splice(index, 1);
        return updatedList;
    },

    logError: (error: AxiosError) => {
        console.log('Request Error', error, error.response);
    },

    replaceImgByAmp: (root: HTMLElement) => {
        root.querySelectorAll('img').forEach((i, index) => {
            console.log({ src: i.src, alt: i.alt, width: i.width, height: i.height });
            let el = `<amp-img src="${i.src}" height="${i.height}" width="${i.width}" alt="${i.alt}" layout="responsive" />`
            i.insertAdjacentHTML('beforebegin', el);
            i.remove();
        })
        return root.innerHTML;
    }

}



export default utilities;